(function () {
    'use strict';

    // @ngInject
    function CompanySettingsIntegrationsControllerCtor($scope, $injector, AnalyticsService, UsersManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CompanySettingsIntegrationsController';
        AnalyticsService.trackPageView(this, 'CompanySettingsIntegrationsView');

        this.user = UsersManager.getCurrUser();
    }

    Controllers.CompanySettingsIntegrationsController = Class(Controllers.BaseController, {
        constructor: CompanySettingsIntegrationsControllerCtor
    });
}());
